module.exports = __webpack_public_path__ + "static/media/godOfMars-0.2f48dcc4.png";